import { HALLOWEEN_PROMO_GIFT_COUPON } from '../campaign';

export const FREESHIPPING_COUPON_CODE = 'newfreeship';

export const COUPONS_EXEMPT_FROM_LIMIT = [FREESHIPPING_COUPON_CODE, HALLOWEEN_PROMO_GIFT_COUPON];
